import React, { Component, Fragment } from 'react'
import styled from 'styled-components'
import defaultTheme from '@ntuctech/devex-tangram/Theme/defaultTheme'
import FilterList from './FilterList'
import { SCREEN_SIZE, Media } from '../../lib/Media'
import Text from '../Text/Text'
import { withRouter } from 'next/router'
import { mapFiltersFromUrl } from '../../lib/filterFormatter'
import queryStringConverter from 'query-string'
import { capitalizeFirstLetterLowercaseOther } from '../../lib/stringHelperFunctions'
import isEmpty from 'lodash/isEmpty'
import { disablePageScroll } from '../../lib/utils'
import SvgFilter from '../icons/Filter'

// For maintaining the order of filters
const FILTERORDER = {
  brand: 1,
  price: 2,
  'Country of Origin': 3,
  'Dietary Attributes': 4,
  tag: 5,
  PWP: 6,
}

const Block = styled.div`
  display: block;
`

const StyledSidebar = styled.div`
  z-index: 10006;
  height: 100vh;
  > :not(:first-child):not(:last-child) {
    border-bottom: 0.025rem solid ${defaultTheme.ColorBaseMineShaft80};
  }
  display: ${({ isVisible }) => (isVisible ? 'block' : 'none')};
  background-color: #ffffff !important;
  top: 0;
  left: 0;
  position: fixed;
  overflow: auto;
  padding-bottom: 8rem;
  ${SCREEN_SIZE.Only.Tablet} {
    top: 8rem;
  }
  ${SCREEN_SIZE.From.Desktop} {
    position: relative;
    padding-bottom: 0;
  }
`
const StyledBackdrop = styled.div`
  background-color: rgba(51, 51, 51, 0.8);
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10005;
  overflow: auto;
  outline: none;
  display: ${({ isVisible }) => (isVisible ? 'block' : 'none')};
  ${SCREEN_SIZE.Only.Tablet} {
    position: fixed;
    top: 8.05rem;
  }
`
const FilterCategoryContainer = styled.div`
  width: 15.5rem;
  display: flex;
  flex-direction: column;
`

const HeadingContainer = styled.div`
  display: flex;
  padding: ${props =>
    props.resetPadding ? '0 1rem 0.5rem' : '1rem 1rem 0.5rem'};
  justify-content: space-between;
  ${SCREEN_SIZE.From.Desktop} {
    padding: ${props =>
      props.resetPadding ? '0 1rem 0.75rem' : '1rem 1rem 0.75rem'};
  }
`

const Heading = styled.h2`
  color: ${props => (props.color ? props.color : '#000000')};
  cursor: ${props => (props.cursor ? props.cursor : 'unset')};
  align-self: flex-end;
  line-height: 1.5rem;
`

const ClearFilters = styled.span`
  color: ${props => (props.color ? props.color : '#000000')};
  cursor: ${props => (props.cursor ? props.cursor : 'unset')};
  line-height: 1rem;
  margin-left: auto;
`

const FilterButtonDiv = styled.div`
  display: flex;
  min-width: ${({ variant }) => (variant === 'sitemap' ? 'auto' : '4.938rem')};
  width: ${({ variant, isCount }) =>
    variant === 'sitemap' ? 'auto' : isCount ? '6.25rem' : '4.938rem'};
  height: ${({ variant }) => (variant === 'sitemap' ? 'auto' : '2.25rem')};
  background-color: ${({ isCount }) => (isCount ? '#E8F0FD' : 'white')};
  align-items: center;
  padding: ${({ variant }) =>
    variant === 'sitemap'
      ? '0.625rem 0.2rem 0.625rem 0.625rem'
      : '0.5rem 0.75rem 0.5rem 0.75rem'};
  margin-right: 0.5rem;
  cursor: pointer;
  border-radius: ${({ variant }) =>
    variant === 'sitemap' ? '2rem' : '0.375rem'};
  ${SCREEN_SIZE.Below.Tablet} {
    border: ${({ variant }) =>
      variant === 'sitemap' ? 'none' : '1px solid #cccccc'};
    border-color: ${({ isCount }) => (isCount ? '#1454B8' : '#cccccc')};
    box-shadow: ${({ variant }) =>
      variant === 'sitemap' ? '0 13px 15px 0 rgba(0, 0, 0, 0.12)' : 'none'};
  }

  &:active {
    background-color: #e8f0fd;
    border: 2px solid #1454b8;
  }
`

const StyledFilterInactive = styled(SvgFilter)`
  margin-right: 0.375rem;
  width: 0.667rem;
  height: 0.75rem;
`

const FilterForMobileAndTablet = styled.div`
  ${SCREEN_SIZE.From.Desktop} {
    display: none;
  }
`

const FilterForDesktopAndHd = styled.div`
  display: none;
  ${SCREEN_SIZE.From.Desktop} {
    display: block;
    background: #ffffff;
    > div:not(:first-child):not(:last-child) {
      border-bottom: 0.025rem solid #eaeaea;
    }
  }
`

const StyledText = styled(Text)`
  white-space: nowrap;
`

const StyledButton = styled.div`
  outline: none;
`
const TopHeading = styled.p`
  color: #696969;
  padding: 1rem;
  display: flex;
  align-items: center;

  .filterBy {
    letter-spacing: 0.0625rem;
  }

  ${SCREEN_SIZE.From.Desktop} {
    padding: 0.5rem 1rem 0.25rem;
  }
`

const FilterKeyList = ({
  displayType,
  isEnabledApiExperiment,
  keys,
  checkedFilters,
  newData,
  onClick,
}) => {
  return keys.map((element, id) => {
    // change `tag` heading of filters to promotions
    const heading = element === 'tag' ? 'promotions' : element
    return (
      <FilterCategoryContainer key={element + id}>
        <HeadingContainer resetPadding={id === 0}>
          <Heading>
            <Text
              size="large"
              weight="bold"
              color={defaultTheme.ColorBaseMineShaft700}
            >
              {capitalizeFirstLetterLowercaseOther(heading)}
            </Text>
          </Heading>
        </HeadingContainer>
        <FilterList
          data={newData[element]}
          displayType={displayType}
          onClick={onClick}
          heading={element}
          checkedFilters={checkedFilters && checkedFilters[element]}
          isEnabledApiExperiment={isEnabledApiExperiment}
        />
      </FilterCategoryContainer>
    )
  })
}

class Filter extends Component {
  constructor(props) {
    super(props)
    this.state = {
      checkedFilters:
        this.props.defaultValue ||
        mapFiltersFromUrl(this.props.router?.query?.filter),
    }

    this.handleClick = this.handleClick.bind(this)
    this.handleClear = this.handleClear.bind(this)
    this.handlePopState = this.handlePopState.bind(this)
  }

  componentDidMount() {
    window.addEventListener('popstate', this.handlePopState)
  }

  componentWillUnmount() {
    window.removeEventListener('popstate', this.handlePopState)
  }

  handlePopState(event) {
    if (!event.state) {
      return
    }

    const urlParts = event.state.url.split('?')
    const queryString = urlParts.length > 1 ? urlParts[1] : ''
    const query = queryStringConverter.parse(queryString)

    const newCheckedFilters = mapFiltersFromUrl(query.filter)
    this.setState({ checkedFilters: newCheckedFilters })
  }

  handleClear() {
    this.props.onApplyFilters && this.props.onApplyFilters({})
  }

  handleClick(param, key) {
    const checkedFilters = mapFiltersFromUrl(this.props.router?.query?.filter)
    if (checkedFilters.hasOwnProperty(key)) {
      const index = checkedFilters[key].indexOf(param.slug)
      if (index > -1) {
        if (checkedFilters[key].length > 1) {
          checkedFilters[key].splice(index, 1)
        } else {
          delete checkedFilters[key]
        }
      } else {
        checkedFilters[key].push(param.slug)
      }
    } else {
      checkedFilters[key] = [param.slug]
    }
    const selectedFilter = {
      category: key,
      label: param?.name,
      checked: param?.checked,
    }
    this.props.onApplyFilters &&
      this.props.onApplyFilters(checkedFilters, selectedFilter)
  }

  render() {
    const { variant, data, except, isEnabledApiExperiment } = this.props
    const { isVisibleSidebar } = this.state

    const newData = except
      ? Object.keys(data).reduce((acc, current) => {
          const included = !except.includes(current)
          if (included) {
            return {
              ...acc,
              [current]: data[current],
            }
          } else {
            return {
              ...acc,
            }
          }
        }, {})
      : data

    let keys = Object.keys(newData || {})

    if (!isEnabledApiExperiment) {
      keys =
        keys &&
        keys
          .filter(key => newData[key].length)
          .sort((keyA, keyB) => FILTERORDER[keyA] - FILTERORDER[keyB])
    }
    const checkedFilters = mapFiltersFromUrl(this.props.router?.query?.filter)

    const openSidebar = () => {
      this.setState({ isVisibleSidebar: true })
      disablePageScroll(true)
    }
    const closeSidebar = () => {
      this.setState({ isVisibleSidebar: false })
      disablePageScroll(false)
    }

    return (
      <Fragment>
        <Media query={SCREEN_SIZE.Below.Desktop}>
          <FilterForMobileAndTablet>
            <Block>
              <StyledButton onClick={openSidebar}>
                <FilterButtonDiv
                  variant={variant}
                  isCount={this.props.filterCount}
                >
                  <StyledFilterInactive
                    color={
                      this.props.filterCount
                        ? '#1454B8'
                        : defaultTheme.ColorBaseMineShaft700
                    }
                  />
                  {variant !== 'sitemap' && (
                    <Text
                      size="medium"
                      color={
                        this.props.filterCount
                          ? '#1454B8'
                          : defaultTheme.ColorBaseMineShaft700
                      }
                      weight="bold"
                    >
                      Filter{' '}
                      {this.props.filterCount
                        ? `(${this.props.filterCount})`
                        : ''}
                    </Text>
                  )}
                </FilterButtonDiv>
              </StyledButton>
              <StyledBackdrop
                isVisible={isVisibleSidebar}
                onClick={closeSidebar}
              />
              <StyledSidebar isVisible={isVisibleSidebar}>
                <TopHeading>
                  <Text
                    className="filterBy"
                    size="small"
                    weight="bold"
                    color={defaultTheme.ColorBaseMineShaft500}
                  >
                    FILTER BY
                  </Text>
                  {!isEmpty(checkedFilters) && (
                    <ClearFilters
                      onClick={this.handleClear}
                      color="#c10b3a"
                      cursor="pointer"
                    >
                      <Text size="medium" weight="bold">
                        Clear all
                      </Text>
                    </ClearFilters>
                  )}
                </TopHeading>
                <FilterKeyList
                  checkedFilters={checkedFilters}
                  newData={newData}
                  keys={keys}
                  displayType={'mobile'}
                  isEnabledApiExperiment={isEnabledApiExperiment}
                  onClick={this.handleClick}
                />
              </StyledSidebar>
            </Block>
          </FilterForMobileAndTablet>
        </Media>
        <Media query={SCREEN_SIZE.From.Desktop}>
          <FilterForDesktopAndHd>
            <TopHeading>
              <Text
                className="filterBy"
                size="small"
                weight="black"
                color={defaultTheme.ColorBaseMineShaft500}
              >
                FILTER BY
              </Text>
              {!isEmpty(checkedFilters) && (
                <ClearFilters
                  onClick={this.handleClear}
                  color="#c10b3a"
                  cursor="pointer"
                  data-testid="clear-all-filters"
                >
                  <StyledText size="medium" weight="bold">
                    Clear all
                  </StyledText>
                </ClearFilters>
              )}
            </TopHeading>
            <FilterKeyList
              checkedFilters={checkedFilters}
              newData={newData}
              keys={keys}
              displayType={'desktop'}
              isEnabledApiExperiment={isEnabledApiExperiment}
              onClick={this.handleClick}
            />
          </FilterForDesktopAndHd>
        </Media>
      </Fragment>
    )
  }
}

Filter.defaultProps = {
  isEnabledApiExperiment: false,
}

export default withRouter(Filter)
